<template>
  <div style="height:100%;" class="d-flex justify-center">
    <v-dialog v-model="dialogSuccess" persistent max-width="600">
      <v-card>
        <div class="d-flex flex-column align-items-center pa-4">
          <sweetalert-icon icon="success" />
          <p class="font-weight-medium text-center title">Contraseña actualizada</p>
          <p class="text-center">
            Tu contraseña ha sido actualizada exitosamente. Ya puedes iniciar sesión con tu nueva contraseña.
          </p>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn to="/ingreso" color="primary" class="container">Ir a Iniciar Sesión</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="d-flex flex-column align-center pa-4 mt-8" style="max-width:600px">
      <div class="d-flex justify-start">
        <div class="d-flex flex-column" style="width: 350px;">
          <span class="font-weight-light title mb-4 text-center">Crear nueva contraseña</span>

          <v-alert v-if="tokenError" type="error" dense class="mb-4">
            {{ tokenError }}
          </v-alert>

          <v-form ref="form" v-model="formValidated" v-if="!tokenError">
            <v-text-field
              v-model="password"
              label="Nueva contraseña"
              outlined
              :rules="[
                () => !!password || 'Campo requerido',
                () => password.length >= 4 || 'Mínimo 4 caracteres'
              ]"
              type="password"
            ></v-text-field>

            <v-text-field
              v-model="passwordConfirm"
              label="Confirmar contraseña"
              outlined
              :rules="[
                () => !!passwordConfirm || 'Campo requerido',
                () => password === passwordConfirm || 'Las contraseñas no coinciden'
              ]"
              type="password"
            ></v-text-field>

            <v-btn
              @click="resetPassword"
              :disabled="!formValidated"
              color="primary"
              class="container"
            >Restablecer contraseña</v-btn>
          </v-form>

          <v-btn to="/ingreso" text class="mt-4">Volver a Iniciar Sesión</v-btn>
        </div>
      </div>
    </div>

    <!-- Snackbar para mostrar errores específicos del backend -->
    <v-snackbar
      v-model="showError"
      :timeout="6000"
      color="error"
      top
    >
      {{ errorMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="showError = false"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "ResetPassword",
  data: () => ({
    formValidated: true,
    token: "",
    password: "",
    passwordConfirm: "",
    dialogSuccess: false,
    showError: false,
    errorMessage: "",
    tokenError: null
  }),
  mounted() {
    // Obtener token de la URL
    this.token = this.$route.query.token;
    if (!this.token) {
      this.tokenError = "Token inválido. Por favor, solicita un nuevo enlace de recuperación.";
    }
  },
  methods: {
    async resetPassword() {
      if (!this.$refs.form.validate()) {
        return;
      }

      try {
        const axios = require("axios");
        let { data } = await axios.post("resetPassword", {
          token: this.token,
          password: this.password
        });

        if (data.ok) {
          this.dialogSuccess = true;
        }
      } catch (err) {
        this.errorMessage = (err.response && err.response.data && err.response.data.msg) ||
                            (err.response && err.response.data && err.response.data.message) ||
                            'Error al restablecer contraseña. Intente nuevamente.';
        this.showError = true;
        console.error('Error en resetPassword:', err);
      }
    }
  }
};
</script>

<style scoped>
</style>
